import styled from 'styled-components';

export default styled.div`
  min-height: calc(100vh - 170px);

  display: flex;
  justify-content: space-around;
  align-items: center;

  max-width: 1200px;
  margin: auto;
  flex-wrap: wrap-reverse;

  .left {
    display: flex;
    flex-direction: column;
    max-width: 350px;
    padding: 0 20px;

    img {
      width: 126px;
      margin-bottom: 56px;
    }

    .title {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    button {
      margin-top: 24px;
      max-width: 200px;
    }
  }

  .right {
    img {
      width: 586px;
      height: auto;
      margin: auto;
      display: block;
    }
  }

  @media (max-width: 1000px) {
    .right {
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .right {
      img {
        width: 100%;
      }
    }
  }
`;
